import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { useMedia } from "react-use";

import { Anchor } from "@/components/Anchor";
import { Section } from "@/components/Section";
import { Text } from "@/components/Text";
import { TextListWithDot } from "@/components/TextListWithDot";
import { MEDIA_SIZE_SM } from "@/core/media";
import { getJobRequestClientInfo, IJobRequest } from "@/data/job-requests";
import { Flex, Tooltip } from "@/eworkitComponents";
import { useFormats } from "@/hooks/Formats";
import { router } from "@/views/router";

interface IJobRequestSubHeaderProps {
  record: IJobRequest;
}

export const JobRequestSubHeader: FC<IJobRequestSubHeaderProps> = ({ record }) => {
  const { t } = useTranslation("session");
  const { formatDate } = useFormats();
  const isSmallScreen = useMedia(MEDIA_SIZE_SM);
  const elements = [];
  const baseClass = "job-request-icon-header";

  const clientInfo = getJobRequestClientInfo(record);

  if (record.systemId) {
    elements.push(
      <Text key="jr-id" color="grey1">
        {record.systemId}
      </Text>,
    );
  }

  if (!record.public) {
    elements.push(
      <Tooltip placement="bottom" content={t("JOB_REQUESTS.DETAIL.VISIBLE_ONLY_TO_YOU")} key="dates">
        <Section background="light-green" className={`${baseClass}__exclusive`} shadow="none">
          <Flex align="center" justify="center" margin={["sm"]}>
            <Text key="dedicated" color="dark-green">
              {t("JOB_REQUESTS.DETAIL.EXCLUSIVE")}
            </Text>
          </Flex>
        </Section>
      </Tooltip>,
    );
  }

  if (record.firstDayOfApplications && record.origin) {
    const publishedDate = formatDate(record.firstDayOfApplications);
    const publishDate = (
      <Flex
        key="publish-date"
        direction={isSmallScreen ? "column" : "row"}
        innerMargin={!isSmallScreen ? "xs" : undefined}>
        <Text color="grey1">{t("JOB_REQUESTS.DETAIL.PUBLISHED_ON", { publishedDate })}</Text>

        {clientInfo.legalEntity?.publicProfileSlug ? (
          <Anchor
            align="left"
            href={
              router.get("public-client", {
                slug: clientInfo.legalEntity.publicProfileSlug,
              }).path
            }>
            {clientInfo.name}
          </Anchor>
        ) : (
          <Text color="black">{clientInfo.name}</Text>
        )}
      </Flex>
    );
    elements.push(publishDate);
  }

  return isSmallScreen ? (
    <Flex direction="column" innerPadding={isSmallScreen ? "xs" : undefined}>
      {elements}
    </Flex>
  ) : (
    <TextListWithDot>{elements}</TextListWithDot>
  );
};
